import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsAPI } from '../lib/api';

/**
 * Hook to track page views automatically
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view
    const trackPageView = async () => {
      try {
        await analyticsAPI.track({
          event_type: 'page_view',
          page: document.title,
          resource_id: null,
          resource_type: null,
          metadata: {
            path: location.pathname,
            search: location.search,
          }
        });
      } catch (err) {
        // Silent fail - don't break the app
        console.debug('Analytics tracking failed:', err);
      }
    };

    trackPageView();
  }, [location.pathname]);
};

/**
 * Track custom events
 */
export const trackEvent = async (eventType, resourceType = null, resourceId = null, metadata = {}) => {
  try {
    await analyticsAPI.track({
      event_type: eventType,
      page: document.title,
      resource_id: resourceId,
      resource_type: resourceType,
      metadata
    });
  } catch (err) {
    console.debug('Analytics tracking failed:', err);
  }
};

/**
 * Track guide view
 */
export const trackGuideView = (guideId) => {
  trackEvent('page_view', 'guide', guideId);
};

/**
 * Track blog view
 */
export const trackBlogView = (blogSlug) => {
  trackEvent('page_view', 'blog', blogSlug);
};

/**
 * Track service click
 */
export const trackServiceClick = (serviceId) => {
  trackEvent('service_click', 'service', serviceId);
};

/**
 * Track guide download
 */
export const trackGuideDownload = (guideId) => {
  trackEvent('guide_download', 'guide', guideId);
};

/**
 * Track lead submission
 */
export const trackLeadSubmit = (serviceId = null) => {
  trackEvent('lead_submit', 'service', serviceId);
};
